import React, { useEffect, useRef } from 'react';

import { ModalInputStyled } from './styles';

const Input = props => {
  const { autoFocus, value, placeholder, onChange } = props;
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 0);
    }
  }, [autoFocus]);

  return <ModalInputStyled ref={inputRef} value={value} placeholder={placeholder} onChange={onChange} />;
};

export default Input;
